import { useState, useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import JsonData from "./data/data.json";
import locdata from "./data/locdata.json";

import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Navigation } from "./components/navigation";
import Home from "./Home";
import { Errorpage } from "./components/pages/errorpage";
import { Thanks } from "./components/pages/thanks";
import { Footer } from "./components/footer";
import Footerdetail from "./components/Footerdetail";
import { Privacypolicy } from "./components/pages/privacypolicy";
import { AboutDetail } from "./components/pages/aboutdetail";
import { PrivacyPolicies2 } from "./components/privacypolicy2";
import { Alcohol } from "./components/pages/issueaddiction/alcohol";
import { Drug } from "./components/pages/issueaddiction/drugs"
import { Cocaine } from "./components/pages/issueaddiction/cocaine";
import { Heroin } from "./components/pages/issueaddiction/heroin";
import { Marijuana } from "./components/pages/issueaddiction/marijuana";
import { Whitener } from "./components/pages/issueaddiction/whitener";
import { BrownSugar } from "./components/pages/issueaddiction/brownsugar";
import { Injection } from "./components/pages/issueaddiction/injection";
import { Tablets } from "./components/pages/issueaddiction/tablets";
import HnHome from "./components/language/HindiHome";
import { AboutDetailHi } from "./components/language/hindi/aboutdetailhi";
import { AlcoholHin } from "./components/language/hindi/issueaddiction/alcohol";
import { CocaineHin } from "./components/language/hindi/issueaddiction/cocaine";
import { DrugHin } from "./components/language/hindi/issueaddiction/drugs";
import { HeroinHin } from "./components/language/hindi/issueaddiction/heroin";
import { MarijuanaHin } from "./components/language/hindi/issueaddiction/marijuana";
import { WhitenerHin } from "./components/language/hindi/issueaddiction/whitener";
import { BrownSugarHin } from "./components/language/hindi/issueaddiction/brownsugar";
import { InjectionHin } from "./components/language/hindi/issueaddiction/injection";
import { TabletsHin } from "./components/language/hindi/issueaddiction/tablets";
import { Demoloc } from "./components/location/demoloc";
import { Bihar } from "./components/location/Bihar";
import Biharnearme from "./components/location/nearmelink/Biharnearme";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});


const App = () => {


  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      
        <div className='social'>
        <div>
          <a className="whatsapp" href="https://api.whatsapp.com/send?phone=919122808152" target="_blank" rel="noreferrer">
            <i className="fa fa-whatsapp"></i>
          </a>
        </div>
        <div>
          <a className="phone" href="tel:9122808152" target="_blank" rel="noreferrer">
            <i className="fa fa-phone"></i>
          </a>
        </div>
      </div>
        
      <Navigation />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/aboutus-detail" element={<AboutDetail data={landingPageData.Uddes} />} />
        <Route path="/alcohol-addiction-treatment-patna" element={<Alcohol />}/>
        <Route path="/cocaine-addiction-treatment-patna" element={<Cocaine />}/>
        <Route path="/drug-addiction-treatment-patna" element={<Drug />}/>
        <Route path="/heroin-addiction-treatment-patna" element={<Heroin />}/>
        <Route path="/marijuana-addiction-treatment-patna" element={<Marijuana />}/>
        <Route path="/whitener-addiction-treatment-patna" element={<Whitener />}/>
        <Route path="/brownsugar-addiction-treatment-patna" element={<BrownSugar />}/>
        <Route path="/injection-addiction-treatment-patna" element={<Injection />}/>
        <Route path="/tablet-addiction-treatment-patna" element={<Tablets />}/>


        <Route path="/alcohol-addiction-treatment-patna-hin" element={<AlcoholHin />}/>
        <Route path="/cocaine-addiction-treatment-patna-hin" element={<CocaineHin />}/>
        <Route path="/drug-addiction-treatment-patna-hin" element={<DrugHin />}/>
        <Route path="/heroin-addiction-treatment-patna-hin" element={<HeroinHin />}/>
        <Route path="/marijuana-addiction-treatment-patna-hin" element={<MarijuanaHin />}/>
        <Route path="/whitener-addiction-treatment-patna-hin" element={<WhitenerHin />}/>
        <Route path="/brownsugar-addiction-treatment-patna-hin" element={<BrownSugarHin />}/>
        <Route path="/injection-addiction-treatment-patna-hin" element={<InjectionHin />}/>
        <Route path="/tablet-addiction-treatment-patna-hin" element={<TabletsHin />}/>

        <Route path="/hnhome" element={<HnHome />}/>
        <Route path="/aboutus-detail-hn" element={<AboutDetailHi />}/>


        <Route path="/Nasha-mukti-kendra-bhagalpur" element={<Demoloc title={locdata.Bhagalpur.title} number={locdata.Bhagalpur.number} />} />

        

        <Route path="/Nasha-mukti-kendra-Araria" element={<Bihar title={locdata.Araria.title} number={locdata.Araria.number} />} />
        <Route path="/Nasha-mukti-kendra-Arwal" element={<Bihar title={locdata.Arwal.title} number={locdata.Arwal.number} />} />
        <Route path="/Nasha-mukti-kendra-Aurangabad" element={<Bihar title={locdata.Aurangabad.title} number={locdata.Aurangabad.number} />} />
        <Route path="/Nasha-mukti-kendra-Banka" element={<Bihar title={locdata.Banka.title} number={locdata.Banka.number} />} />
        <Route path="/Nasha-mukti-kendra-Begusarai" element={<Bihar title={locdata.Begusarai.title} number={locdata.Begusarai.number} />} />
        <Route path="/Nasha-mukti-kendra-Bhabua" element={<Bihar title={locdata.Bhabua.title} number={locdata.Bhabua.number} />} />
        <Route path="/Nasha-mukti-kendra-Bhagalpur" element={<Bihar title={locdata.Bhagalpur.title} number={locdata.Bhagalpur.number} />} />
        <Route path="/Nasha-mukti-kendra-Bhojpur" element={<Bihar title={locdata.Bhojpur.title} number={locdata.Bhojpur.number} />} />
        <Route path="/Nasha-mukti-kendra-Bihar-Sharif" element={<Bihar title={locdata.BiharSharif.title} number={locdata.BiharSharif.number} />} />
        <Route path="/Nasha-mukti-kendra-Buxar" element={<Bihar title={locdata.Buxar.title} number={locdata.Buxar.number} />} />
        <Route path="/Nasha-mukti-kendra-Sultanganj" element={<Bihar title={locdata.Sultanganj.title} number={locdata.Sultanganj.number} />} />
        <Route path="/Nasha-mukti-kendra-kahalgaon" element={<Bihar title={locdata.kahalgaon.title} number={locdata.kahalgaon.number} />} />
        <Route path="/Nasha-mukti-kendra-Bakhtiyarpur" element={<Bihar title={locdata.Bakhtiyarpur.title} number={locdata.Bakhtiyarpur.number} />} />
        <Route path="/Nasha-mukti-kendra-Barh" element={<Bihar title={locdata.Barh.title} number={locdata.Barh.number} />} />
        <Route path="/Nasha-mukti-kendra-Jamalpur" element={<Bihar title={locdata.Jamalpur.title} number={locdata.Jamalpur.number} />} />
        <Route path="/Nasha-mukti-kendra-Motihari" element={<Bihar title={locdata.Motihari.title} number={locdata.Motihari.number} />} />
        <Route path="/Nasha-mukti-kendra-Bettiah" element={<Bihar title={locdata.Bettiah.title} number={locdata.Bettiah.number} />} />
        <Route path="/Nasha-mukti-kendra-Barahat" element={<Bihar title={locdata.Barahat.title} number={locdata.Barahat.number} />} />
        <Route path="/Nasha-mukti-kendra-Mandar-Hill" element={<Bihar title={locdata.MandarHill.title} number={locdata.MandarHill.number} />} />
        <Route path="/Nasha-mukti-kendra-Raxaul" element={<Bihar title={locdata.Raxaul.title} number={locdata.Raxaul.number} />} />
        <Route path="/Nasha-mukti-kendra-Chhapra" element={<Bihar title={locdata.Chhapra.title} number={locdata.Chhapra.number} />} />
        <Route path="/Nasha-mukti-kendra-Darbhanga" element={<Bihar title={locdata.Darbhanga.title} number={locdata.Darbhanga.number} />} />
        <Route path="/Nasha-mukti-kendra-East-Champaran" element={<Bihar title={locdata.EastChamparan.title} number={locdata.EastChamparan.number} />} />
        <Route path="/Nasha-mukti-kendra-Gaya" element={<Bihar title={locdata.Gaya.title} number={locdata.Gaya.number} />} />
        <Route path="/Nasha-mukti-kendra-Gopalganj" element={<Bihar title={locdata.Gopalganj.title} number={locdata.Gopalganj.number} />} />
        <Route path="/Nasha-mukti-kendra-Jamui" element={<Bihar title={locdata.Jamui.title} number={locdata.Jamui.number} />} />
        <Route path="/Nasha-mukti-kendra-Jehanabad" element={<Bihar title={locdata.Jehanabad.title} number={locdata.Jehanabad.number} />} />
        <Route path="/Nasha-mukti-kendra-Khagaria" element={<Bihar title={locdata.Khagaria.title} number={locdata.Khagaria.number} />} />
        <Route path="/Nasha-mukti-kendra-Kishanganj" element={<Bihar title={locdata.Kishanganj.title} number={locdata.Kishanganj.number} />} />
        <Route path="/Nasha-mukti-kendra-Kaimur" element={<Bihar title={locdata.Kaimur.title} number={locdata.Kaimur.number} />} />
        <Route path="/Nasha-mukti-kendra-Katihar" element={<Bihar title={locdata.Katihar.title} number={locdata.Katihar.number} />} />
        <Route path="/Nasha-mukti-kendra-Lakhisarai" element={<Bihar title={locdata.Lakhisarai.title} number={locdata.Lakhisarai.number} />} />
        <Route path="/Nasha-mukti-kendra-Madhubani" element={<Bihar title={locdata.Madhubani.title} number={locdata.Madhubani.number} />} />
        <Route path="/Nasha-mukti-kendra-Munger" element={<Bihar title={locdata.Munger.title} number={locdata.Munger.number} />} />
        <Route path="/Nasha-mukti-kendra-Madhepura" element={<Bihar title={locdata.Madhepura.title} number={locdata.Madhepura.number} />} />
        <Route path="/Nasha-mukti-kendra-Muzaffarpur" element={<Bihar title={locdata.Muzaffarpur.title} number={locdata.Muzaffarpur.number} />} />
        <Route path="/Nasha-mukti-kendra-Nalanda" element={<Bihar title={locdata.Nalanda.title} number={locdata.Nalanda.number} />} />
        <Route path="/Nasha-mukti-kendra-Nawada" element={<Bihar title={locdata.Nawada.title} number={locdata.Nawada.number} />} />
        <Route path="/Nasha-mukti-kendra-Patna" element={<Bihar title={locdata.Patna.title} number={locdata.Patna.number} />} />
        <Route path="/Nasha-mukti-kendra-Purnia" element={<Bihar title={locdata.Purnia.title} number={locdata.Purnia.number} />} />
        <Route path="/Nasha-mukti-kendra-Rohtas" element={<Bihar title={locdata.Rohtas.title} number={locdata.Rohtas.number} />} />
        <Route path="/Nasha-mukti-kendra-Saharsa" element={<Bihar title={locdata.Saharsa.title} number={locdata.Saharsa.number} />} />
        <Route path="/Nasha-mukti-kendra-Samastipur" element={<Bihar title={locdata.Samastipur.title} number={locdata.Samastipur.number} />} />
        <Route path="/Nasha-mukti-kendra-Sasaram" element={<Bihar title={locdata.Sasaram.title} number={locdata.Sasaram.number} />} />
        <Route path="/Nasha-mukti-kendra-Sheohar" element={<Bihar title={locdata.Sheohar.title} number={locdata.Sheohar.number} />} />
        <Route path="/Nasha-mukti-kendra-Sheikhpura" element={<Bihar title={locdata.Sheikhpura.title} number={locdata.Sheikhpura.number} />} />
        <Route path="/Nasha-mukti-kendra-Saran" element={<Bihar title={locdata.Saran.title} number={locdata.Saran.number} />} />
        <Route path="/Nasha-mukti-kendra-Sitamarhi" element={<Bihar title={locdata.Sitamarhi.title} number={locdata.Sitamarhi.number} />} />
        <Route path="/Nasha-mukti-kendra-Supaul" element={<Bihar title={locdata.Supaul.title} number={locdata.Supaul.number} />} />
        <Route path="/Nasha-mukti-kendra-Siwan" element={<Bihar title={locdata.Siwan.title} number={locdata.Siwan.number} />} />
        <Route path="/Nasha-mukti-kendra-Vaishali" element={<Bihar title={locdata.Vaishali.title} number={locdata.Vaishali.number} />} />
        <Route path="/Nasha-mukti-kendra-West-Champaran" element={<Bihar title={locdata.WestChamparan.title} number={locdata.WestChamparan.number} />} />
        
      </Routes>
   
      {/*
        
      <Route exact path="*" element={<Errorpage />} />
        <Route exact path="/thanks" element={<Thanks />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/return-policy" element={<Returnypolicy />} />
        <Route path="/help-center" element={<Helpcenter />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/faq" element={<Faqp />} />
        <Footerdetail data={landingPageData.Contact} />
        */}
     
      <Biharnearme />
      <Footer data={landingPageData.Footerdetail} />
    </div>

  );
};


export default App;

